<template>
  <div>

    <div v-for="(sval, skey) in sessions" :key="skey">

      <div :style="{ 
        color: sval.session_type ? sval.session_type.value.color : '#000000', 
        background: sval.session_type ? sval.session_type.value.background : '#eeeeee'
      }">

        <table class="details session head" :class="{ divider: skey > 0 }">
          <tr>
            <td colspan="3" v-if="sval.day && (sval.start_time && sval.end_time) && sval.room">
              <span v-if="sval.day">{{ formatDate(sval.day) }}</span>
              <span v-if="sval.start_time && sval.end_time"><br>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
              <span v-if="sval.room" style="float: right">{{ sval.room.name }}</span>
            </td>
          </tr>
          <tr v-if="sval.session_type">
            <td colspan="3"> 
              <span v-if="sval.session_group">{{ sval.session_group.name }}<br></span>
              {{ sval.session_type.name }}
            </td>
          </tr>
          <tr>
            <td colspan="3"> 
              <router-link :to="'/session/' + sval.id + '/edit'">
                <b style="font-size: 16px; line-height: 19px;">
                  <span v-if="sval.code">{{ sval.code }}&nbsp;</span>
                  <span v-html="sval.title"></span>
                </b>
              </router-link>
            </td>
          </tr>
          <tr v-if="sval.content && sval.content.outline">
            <td colspan="3" v-html="sval.content.outline"></td>
          </tr>
        </table>

        <table class="details session persons" v-if="sval.persons.length > 0">
          <tr>
            <td colspan="3">
              <router-link v-for="(pval, pkey) in sval.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                {{ pval.role.name }}: {{ pval.person.first_name }} {{ pval.person.last_name }}
                <span v-if="pval.person.city || pval.person.country"> (</span>
                <span v-if="pval.person.city">{{ pval.person.city }}</span>
                <span v-if="pval.person.city && pval.person.country">, </span>
                <span v-if="pval.person.country">{{ _[pval.person.country.name] }}</span>
                <span v-if="pval.person.city || pval.person.country">)</span>
                <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                <span v-if="pval.person.overlappings.length && pval.person.overlappings.map(overlapping => overlapping.session_id).includes(sval.id)" class="icon"><font-awesome-icon :icon="['fad', 'user-friends']" /></span>
                <br>
              </router-link>
            </td>
          </tr>
        </table>

      </div>

      <div class="presentations" v-if="sval.presentations.length > 0">

        <table class="details session presentations">
          <tr class="empty">
            <td class="code"></td>
            <td class="title"></td>
            <td class="time"></td>
          </tr>
          <tr v-for="(cval, ckey) in sval.presentations" :key="ckey" :class="{ backup: !cval.publish, headline: cval.display_type_id === 11 }">
            <td class="code" v-if="cval.display_type_id !== 11">
              <span v-if="cval.code && cval.display_type_id !== 11">{{ cval.code }}</span>
            </td>
            <td class="title" :colspan="colspan(cval.display_type_id)">
              <router-link :to="'/presentation/' + cval.id + '/edit'"><b v-html="cval.title"></b></router-link>
              <div v-if="cval.persons">
                <router-link v-for="(pval, pkey) in cval.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                  {{ pval.role.name }}: {{ pval.person.first_name }} {{ pval.person.last_name }}
                  <span v-if="pval.person.city || pval.person.country"> (</span>
                  <span v-if="pval.person.city">{{ pval.person.city }}</span>
                  <span v-if="pval.person.city && pval.person.country">, </span>
                  <span v-if="pval.person.country">{{ _[pval.person.country.name] }}</span>
                  <span v-if="pval.person.city || pval.person.country">)</span>
                  <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                  <span v-if="pval.person.overlappings.length && pval.person.overlappings.map(overlapping => overlapping.session_id).includes(sval.id)" class="icon"><font-awesome-icon :icon="['fad', 'user-friends']" /></span>
                  <br>
                </router-link>
              </div>
            </td>
            <td class="time">
              <span v-if="cval.start_time || (settings.presentation.show_empty_times == 1 && cval.display_type_id !== 11)">
                {{ cval.start_time }} &ndash; {{ cval.end_time }}
                <br>{{ cval.duration }} {{ _.minutes_abbreviation }}
                <span v-if="cval.including"><br>{{ _.including_abbreviation }} {{ cval.including }} {{ _.minutes_abbreviation }} {{ _.discussion }}</span>
              </span>
            </td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      sessions: [],
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  methods: {
    colspan(type) {
      return (type === 11) ? 2 : 1;
    }
  },
  async created() {
    const session = await this.axios.get(API_URL + '/sessions/' + this.id + '/details');
    let children = [];
    if (session.data[0].display_type_id === 9) {
      children = session.data[0].children.map(child => child.session_id);
    }
    if (children.length) {
      const sessions = await this.axios.get(API_URL + '/sessions/' + children.join(',') + '/details');
      this.sessions = sessions.data;
      this.setProgress(false);
    } else {
      this.sessions = session.data;
      this.setProgress(false);
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.details {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  td {
    padding: 6px 12px;
    vertical-align: top;
    &.code { width: 80px; }
    &.title { width: 100%; }
    &.time { width: 130px; text-align: right; }
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &.head.divider {
    border-top: 1px solid lighten($primary-color, 80%);
  }
  &.persons tr:first-child td {
    padding-top: 0px;
  }
  &:not(.persons) tr:first-child td {
    padding-top: 16px;
  }
  &.head:last-child td, &.persons:last-child td {
    padding-bottom: 16px;
  }
  &.presentations {
    > tr.empty > td {
      padding: 0;
    }
    > tr.backup > td {
      background: lighten($primary-color, 90%);
    }
    > tr:last-child td {
      padding-bottom: 16px;
    }
    > tr.headline > td {
      padding-top: 22px;
      // border-top: 1px solid lighten($primary-color, 80%);
      border-bottom: 1px solid lighten($primary-color, 80%);
    }
  }
  .icon {
    display: inline-block;
    margin: 0 0 0 4px;
    font-size: 13px;
    &.not_invited {
      color: $primary-color;
      opacity: .3;
    }
    &.invited {
      color: $warning-color;
    }
    &.confirmed {
      color: $success-color;
    }
    &.declined {
      color: $error-color;
    }
    > svg {
      margin-bottom: -1px;
    }
  }
}
</style>
